import React, { useEffect, useState } from "react";
import MetabolomeStyle from "./metabolome.module.css";
import { Select, Table, Tooltip } from "antd";

import styled from "styled-components";
import http from "../../../utils/http";
const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: #e3f2d9; // 修改表头背景颜色
    color: #333; // 修改表头文字颜色
    font-weight: bold; // 修改表头文字加粗
  }
`;
function Metabolome() {
  const [MetabolomeColums, setMetabolomeColums] = useState([]);
  const [MetabolomeData, setMetabolomeData] = useState([]);
  const [SelectVal, setSelectVal] = useState([]);
  useEffect(() => {
    getMetabolome(SelectVal);
  }, [SelectVal]);
  const getMetabolome = (sample) => {
    http
      .get(`/api/metabolomics/?sample=${sample}`)
      .then((res) => {
        let TempleColums = [];
        Object.keys(res[0]).map((key) => {
          TempleColums.push({
            key: key,
            title: key,
            dataIndex: key,
            align: "center",
          });
        });
        setMetabolomeColums(TempleColums);
        setMetabolomeData(res);
      })
      .catch((err) => {});
  };

  return (
    <div className={MetabolomeStyle.Metabolome_app}>
      <div className={MetabolomeStyle.Metabolome_Form_div}>
        <div className={MetabolomeStyle.Metabolome_Form_div_top}>
          Metabolites Results
        </div>
        <div className={MetabolomeStyle.Metabolome_Form_div_content}>
          <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "20%",
                padding: "10px 0",
              }}
            >
              <p style={{ fontWeight: "bold", fontSize: "17px" }}>Variety：</p>
              <p
                style={{
                  border: "1px solid #ccc",
                  width: "70%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "6px 0",
                  fontSize: "15px",
                }}
              >
                Lishui-S2
              </p>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px 0",
              }}
            >
              <p style={{ fontWeight: "bold", fontSize: "17px" }}>Sample：</p>
              <Select
                style={{ width: 300 }}
                mode="multiple"
                options={[
                  {
                    key: "15d_Cotyledon",
                    value: "15d_Cotyledon",
                    label: "15d_Cotyledon",
                  },
                  {
                    key: "Maturity_Cotyledon",
                    value: "Maturity_Cotyledon",
                    label: "Maturity_Cotyledon",
                  },
                  {
                    key: "Maturity_Plumule",
                    value: "Maturity_Plumule",
                    label: "Maturity_Plumule",
                  },
                  {
                    key: "Leaf",
                    value: "Leaf",
                    label: "Leaf",
                  },
                  {
                    key: "Leaf_Stalk",
                    value: "Leaf_Stalk",
                    label: "Leaf_Stalk",
                  },
                  {
                    key: "key:Petals_at_2d_post-flowering,",
                    value: "value:Petals_at_2d_post-flowering,",
                    label: "label:Petals_at_2d_post-flowering",
                  },
                  {
                    key: "Stamens_at_2d_post-flowering",
                    value: "Stamens_at_2d_post-flowering",
                    label: "Stamens_at_2d_post-flowering",
                  },
                  {
                    key: "Pistils_at_2d_post-flowering",
                    value: "Pistils_at_2d_post-flowering",
                    label: "Pistils_at_2d_post-flowering",
                  },
                  {
                    key: "15d_lotus_pod",
                    value: "15d_lotus_pod",
                    label: "15d_lotus_pod",
                  },
                  {
                    key: "Sap_exuded_from_lotus_leaf_wound",
                    label: "Sap_exuded_from_lotus_leaf_wound",
                    value: "Sap_exuded_from_lotus_leaf_wound",
                  },
                ]}
                maxTagCount={1}
                maxTagPlaceholder={(omittedValues) => (
                  <Tooltip
                    overlayStyle={{
                      pointerEvents: "none",
                    }}
                    title={omittedValues.map(({ label }) => label).join(", ")}
                  >
                    <span>Hover Me</span>
                  </Tooltip>
                )}
                onChange={(e) => {
                  setSelectVal(e);
                }}
              />
            </div>
            {/* <div
              style={{
                width: "30%",
                display: "flex",
                alignItems: "center",
                padding: "10px 0",
                marginLeft: "10px",
              }}
            >
              <p style={{ fontWeight: "bold", fontSize: "17px" }}>Search：</p>
              <Search style={{ width: 200 }} />
            </div> */}
          </div>
          <div
            style={{ width: "100%", display: "flex", alignItems: "center" }}
          ></div>
          <StyledTable
            style={{ width: "100%" }}
            bordered
            columns={MetabolomeColums}
            dataSource={MetabolomeData}
            scroll={{
              x: 1500,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Metabolome;
